// WizardSteps.js

import React, { useEffect, useState } from 'react';
import { WizardStepsContainer, StepsContainer } from './styles';
import Step from '../Steps';

const WizardSteps = ({ children, initialStep = 0 }) => {
	const [currentStep, setCurrentStep] = useState(initialStep);

	useEffect(() => {
		handleStepClick(initialStep);
	}, [initialStep])

	const handleStepClick = (index) => {
		if ( index <= initialStep)
			setCurrentStep(index);
	};

	return (
		<WizardStepsContainer>
			<StepsContainer>
				{React.Children.map(children, (child, index) =>
					React.cloneElement(child, {
						active: index === currentStep,
						completed: index < currentStep,
						onClick: () => handleStepClick(index),
						isFirstRender: true
					})
				)}
			</StepsContainer>
			<div>
				{React.Children.map(children, (child, index) =>
					index === currentStep ? (
						<div key={index}>
							{React.cloneElement(child, { active: true, isFirstRender: false })}
						</div>
					) : null
				)}
			</div>
		</WizardStepsContainer>
	);
};

export default WizardSteps;
